import classNames from 'classnames'
import {Fragment} from 'react'

import RowGroup from '../../../../common/Grid/RowGroup'
import type {MatrixColumn} from '../../MatrixBuild.utils'
import {MatrixColumnType} from '../../MatrixBuild.utils'

import MatrixGridBuildStatus from './MatrixGridBuildStatus'

import styles from './MatrixGridRow.css'

type Props = {
  columns: MatrixColumn[]
  isHeader: boolean
  withUnderline: boolean
}

function MatrixGridRow({columns, isHeader, withUnderline}: Props) {
  const renderColumn = (column: MatrixColumn) => (
    <Fragment key={column.id}>
      {(column.type === MatrixColumnType.PARAMETER_NAME ||
        column.type === MatrixColumnType.PARAMETER_VALUE) && (
        <div
          className={classNames(
            isHeader ? styles.header : styles.body,
            styles.column,
            styles[column.type],
          )}
        >
          <div
            className={classNames(styles.columnValue, {[styles.visible]: column.isVisible})}
            title={column.value ?? undefined}
          >
            <span>{column.label || column.value || <span>&nbsp;</span>}</span>
          </div>
        </div>
      )}
      {column.type === MatrixColumnType.BUILD && (
        <MatrixGridBuildStatus buildId={column.value?.id} isVisible={column.isVisible} />
      )}
    </Fragment>
  )

  return (
    <RowGroup gridId="matrixBuild">
      <div className={classNames(styles.row, {[styles.withUnderline]: withUnderline})}>
        {columns.map(column => renderColumn(column))}
      </div>
    </RowGroup>
  )
}

export default MatrixGridRow
